import { render, staticRenderFns } from "./BrandImage.vue?vue&type=template&id=1bc3de4d&"
import script from "./BrandImage.vue?vue&type=script&lang=js&"
export * from "./BrandImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports